import React, { useEffect, useState } from 'react';
import { limit, onSnapshot, orderBy, query } from 'firebase/firestore';
import { activityFeedColl } from '../db';
import { Screen, UserProfile } from '../App';
import type { ActivityFeedItem } from '../utils/activityFeed';

interface Props {
  user: UserProfile;
  navigate: (s: Screen) => void;
}

const MEMORY_ITEMS: { id: Screen; icon: string; title: string; desc: string }[] = [
  { id: 'photos', icon: '▧', title: 'Fotoğraf arşivi', desc: 'Albümler ve dönüp bakmak isteyeceğimiz anlar.' },
  { id: 'notes', icon: '✎', title: 'Gece notları', desc: 'Günün sonunda bize kalan cümleler.' },
  { id: 'music', icon: '♪', title: 'Şarkılarımız', desc: 'Bir ana takılan şarkılar ve küçük notlar.' },
  { id: 'timeline', icon: '⌇', title: 'Zaman çizgisi', desc: 'İlkler ve unutulmasın dediğimiz günler.' },
  { id: 'capsule', icon: '◫', title: 'Zaman kapsülü', desc: 'Şimdiden geleceğe bırakılan şeyler.' },
  { id: 'map', icon: '⌖', title: 'Gittiğimiz yerler', desc: 'Sokaklar, şehirler, bizim haritamız.' },
];

function activityIcon(type: string) {
  if (type === 'question') return '?';
  if (type === 'mood') return '≋';
  if (type === 'night_note') return '✎';
  if (type === 'instant_photo') return '▧';
  if (type === 'heartbeat') return '♡';
  if (type === 'pet_ritual') return '✦';
  if (type === 'pet_care') return '◌';
  return '•';
}

function formatActivityDate(dayKey: string) {
  if (!dayKey) return '';
  const [y, m, d] = dayKey.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long' });
}

export default function MemoriesScreen({ user, navigate }: Props) {
  const [feed, setFeed] = useState<ActivityFeedItem[]>([]);

  useEffect(() => {
    const q = query(activityFeedColl(user.coupleId), orderBy('createdAt', 'desc'), limit(24));
    return onSnapshot(q, snap => {
      setFeed(snap.docs.map(d => ({ id: d.id, ...d.data() } as ActivityFeedItem)));
    });
  }, [user.coupleId]);

  return (
    <main className="hub-screen">
      <header className="hub-hero">
        <p>Anılar</p>
        <h1>Biriken biz.</h1>
        <span>Fotoğraflar, notlar, şarkılar; hepsi kaybolmasın diye.</span>
      </header>

      {feed.length > 0 && (
        <section className="memory-feed">
          <div className="panel-title">
            <small>Son izler</small>
            <b>Günlük akış</b>
          </div>
          <div className="memory-feed-list">
            {feed.slice(0, 8).map(item => (
              <div key={item.id}>
                <span>{activityIcon(item.type)}</span>
                <div>
                  <strong>{item.title}</strong>
                  <p>{item.body || `${item.actorName} küçük bir iz bıraktı.`}</p>
                  <small>{item.actorName} · {formatActivityDate(item.dayKey)}</small>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      <section className="hub-list">
        {MEMORY_ITEMS.map(item => (
          <button key={item.id} className="hub-row" onClick={() => navigate(item.id)}>
            <span>{item.icon}</span>
            <div>
              <strong>{item.title}</strong>
              <small>{item.desc}</small>
            </div>
            <b>›</b>
          </button>
        ))}
      </section>
    </main>
  );
}
